import FullView from '@rebuild/materials/shared/contact_information/FullElemInPC.vue';
import MobFull from '@rebuild/materials/shared/contact_information/mob-full.vue';

export const componentMap = {
	overview: FullView,
	'mob-full': MobFull
};
